import React from "react";
import Slider from "infinite-react-carousel";
import { Link } from "react-router-dom";
import "./demoCarousel.css";

function DemoCarousel({ className, list }) {
  let services = list.map((item, idx) => (
    <div className="name-icon" key={idx} disabled={item.underConstruction}>
      <Link to={`/service-detail/${item.id}`}>
        <div className={`service-icon ${item.image}`}></div>
        <h3>{item.title}</h3>
      </Link>
    </div>
  ));
  const settings = {
    dots: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    wheel: true,
    adaptiveHeight: true,
    autoplay: true,
    autoplaySpeed: 2000
  };

  const settingsMobile = {
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    wheel: true,
    adaptiveHeight: true,
    autoplay: true,
    autoplaySpeed: 2000
  };

  return (
    <div className={`demo-carousel ${className}`}>
      <div className="demo-main-carousel">
        <Slider
          {...settingsMobile}
          ref={ele => {
            window.SlimpleSlider = ele;
          }}
          className="mobile"
          draggable={false}
        >
          {services}
        </Slider>

        <Slider
          {...settings}
          ref={ele => {
            window.SlimpleSlider = ele;
          }}
          className="web"
          draggable={false}
        >
          {services}
        </Slider>
      </div>
    </div>
  );
}

export default DemoCarousel;
